import React, { useState } from 'react'
import { AiOutlineEyeInvisible, AiOutlineEye } from "react-icons/ai";
import toast from 'react-hot-toast';
import { useAppContext } from '../context/AppContext';

const Login = () => {

    const { axios, setToken, navigate } = useAppContext();
    const [formData, setFormData] = useState({
        email: "",
        password: "",
    })

    const [showPassword, setShowPassword] = useState(false);

    function changeHandler(event) {
        setFormData((prevData) => (
            {
                ...prevData,
                [event.target.name]: event.target.value,
            }
        ))
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const { data } = await axios.post("/api/admin/login", { email: formData.email, password: formData.password });

            if (data.success) {
                toast.success("Login Successful");
                setToken(data.token);
                localStorage.setItem('token', data.token);
                axios.defaults.headers.common['Authorization'] = data.token;
                navigate("/");
            }
            else {
                toast.error(data.message);
            }
        } catch (error) {
            toast.error(error.message);
        }
    }

    return (
        <div className='w-full flex justify-center items-center'>
            <form onSubmit={handleSubmit} className="w-full max-w-md bg-white rounded-xl shadow-lg p-8 space-y-6">
                <h2 className="text-2xl font-semibold text-center text-gray-800">
                    Welcome Back
                </h2>
                <p className="text-sm text-center text-gray-500">
                    Login to your admin dashboard
                </p>
                <div>
                    <label className="block text-sm font-medium text-gray-600 mb-1">
                        Email Address <sup className="text-red-500">*</sup>
                    </label>
                    <input
                        name="email"
                        required
                        type="email"
                        value={formData.email}
                        onChange={changeHandler}
                        placeholder="Enter your email address"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                    />
                </div>

                <div className="relative">
                    <label className="block text-sm font-medium text-gray-600 mb-1">
                        Password <sup className="text-red-500">*</sup>
                    </label>
                    <input
                        name="password"
                        required
                        type={showPassword ? "text" : "password"}
                        value={formData.password}
                        onChange={changeHandler}
                        placeholder="Enter your password"
                        className="w-full px-4 py-2 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
                    />
                    <span
                        onClick={() => setShowPassword(prev => !prev)}
                        className="absolute right-3 top-9 cursor-pointer text-gray-500 hover:text-gray-700"
                    >
                        {showPassword ? <AiOutlineEyeInvisible /> : <AiOutlineEye />}
                    </span>
                </div>

                <button
                    type="submit"
                    className="w-full bg-primary text-white py-2 rounded-lg font-medium hover:bg-primary/90 transition-all"
                >
                    Sign In
                </button>

            </form>
        </div>
    )
}

export default Login